export default "<app-alert></app-alert>\r\n<app-loading></app-loading>\r\n<router-outlet></router-outlet>\r\n";